export default __webpack_public_path__ + "static/1305-a6b32631a07b74236cfc738dfd80c45a.gif";